import { EmailTextField } from "@/components/Form/EmailTextField";
import { auth } from "@/libs/firebase";
import { caremeTheme } from "@/libs/theme";
import { Box, Button, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { FirebaseError } from "firebase/app";
import { sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";

export function ResetPassword() {
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		setSubmitting(true);

		const data = new FormData(e.currentTarget);
		const email = (data.get("email") || "") as string;
		try {
			await sendPasswordResetEmail(auth, email, {
				url: process.env.NEXT_PUBLIC_APP_URL || "http://localhost:3000",
				handleCodeInApp: false,
			});
			window.alert("パスワードリセットメールを送信しました。");
		} catch (e) {
			if (e instanceof FirebaseError) {
				switch (e.code) {
					case "auth/user-not-found": {
						window.alert("登録しているメールアドレスのユーザーが存在しません");
						return;
					}
					case "auth/invalid-email": {
						window.alert("メールアドレスの形式が正しくありません。");
						return;
					}
				}
			}
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Container component="main" maxWidth="xs" style={{ padding: 0 }}>
			<Box
				mt={6}
				px={6}
				display="flex"
				flexDirection="column"
				alignContent="center"
			>
				<Typography
					component="h1"
					variant="h6"
					textAlign="center"
					color={caremeTheme.palette.primary.main}
				>
					パスワードの再設定
				</Typography>
				<Typography mt={2} variant="body1" textAlign="center">
					登録したメールアドレスを
					<br />
					入力してください
				</Typography>

				<Box mt={2} width="100%">
					<Box component="form" onSubmit={handleSubmit}>
						<EmailTextField />
						<Button
							type="submit"
							fullWidth
							variant="contained"
							sx={{ mt: 3 }}
							disabled={submitting}
						>
							パスワード再設定メールを送信する
						</Button>
					</Box>
				</Box>
			</Box>
		</Container>
	);
}
